import { render, staticRenderFns } from "./IVRStatisticsSearch.vue?vue&type=template&id=12ccf71e"
import script from "./IVRStatisticsSearch.vue?vue&type=script&lang=ts"
export * from "./IVRStatisticsSearch.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports